import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import PdpConfig from 'utils/PdpConfig';
import Rudderstack from 'utils/Rudderstack';
import Settings from 'utils/Settings';

const PdpReviewsStarsJumplink = ({ className }) => {
  const { yotpoStarRatingInstanceId } = Settings;
  const {
    reviewsProductId,
    masterName,
    gender,
    fullName,
    type: category,
    reviewsRatingValue,
  } = PdpConfig;

  useEffect(() => {
    const starRatingContainer = document.getElementById('yotpo-star-rating');
    if (!starRatingContainer) return;

    const handleClick = event => {
      const summary = event.target.closest('.yotpo-sr-bottom-line-summary');
      if (summary) {
        Rudderstack.reviewsStarsClicked({
          gender,
          masterName,
          fullName,
          category,
          reviewRating: reviewsRatingValue,
        });
      }
    };

    starRatingContainer.addEventListener('click', handleClick);
    return () => starRatingContainer.removeEventListener('click', handleClick);
  }, [gender, masterName, fullName, category, reviewsRatingValue]);

  return (
    <div
      id="yotpo-star-rating"
      className={`yotpo-widget-instance ${className || ''}`}
      data-yotpo-instance-id={yotpoStarRatingInstanceId}
      data-yotpo-product-id={reviewsProductId}
      data-yotpo-section-id="product"
    />
  );
};

PdpReviewsStarsJumplink.propTypes = {
  className: PropTypes.string,
};

export default PdpReviewsStarsJumplink;
